// styles
import "./BottomNavigation.scss";

// icons
import {
  HomeIcon,
  ShoppingCartIcon,
  UserIcon,
  PaymentListIcon,
} from "../Icons/Icons";

// react & hooks
import { useLocation } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { useContext } from "react";

// components
import ShoppingCartItemContext from "../../../context/ShoppingCart/ShoppingCartItemContext.tsx";

export default function BottomNavigation() {
  const location = useLocation();
  const { shopCount, getItemCountPerShop, shoppingList } = useContext(
    ShoppingCartItemContext
  );

  const navItems = [
    {
      title: (
        <label
          className="text-center txt-t3-m"
          style={{ width: 22, height: 18 }}
        >
          {" "}
          خانه
        </label>
      ),
      component: (
        <HomeIcon
          width="20px"
          height="20px"
          iconClassName={`${"/" === location.pathname && "active-stroke"}`}
        />
      ),
      url: "",
    },
    {
      title: (
        <label
          className="text-center txt-t3-m"
          style={{ width: 49, height: 18 }}
        >
          {" "}
          سبد خرید
        </label>
      ),
      component: (
        <div style={{ position: "relative" }}>
          <ShoppingCartIcon
            width="20px"
            height="20px"
            iconClassName={`${
              "/shopping-cart" === location.pathname && "active-stroke"
            }`}
          />
          {shopCount != 0 ? (
            <div className="shoppingCount txt-t3-m d-flex justify-content-center align-items-center">
              <span>{shopCount}</span>
            </div>
          ) : (
            <></>
          )}
        </div>
      ),
      url: "shopping-cart",
    },
    {
      title: (
        <label
          className="text-center txt-t3-m"
          style={{ width: 49, height: 18 }}
        >
          {" "}
          سفارش‌ها
        </label>
      ),
      component: (
        <PaymentListIcon
          width="20px"
          height="20px"
          iconClassName={`${"/orders" === location.pathname && "active-fill"}`}
        />
      ),
      url: "orders",
    },
    {
      title: (
        <label
          className="text-center txt-t3-m"
          style={{ width: 68, height: 18 }}
        >
          {" "}
          حساب کاربری
        </label>
      ),
      component: (
        <UserIcon
          width="20px"
          height="20px"
          iconClassName={`${
            "/user-profile" === location.pathname && "active-stroke"
          } `}
        />
      ),
      url: "user-profile",
    },
  ];
  return (
    <div className="bottom-navigation d-flex align-items-center">
      {navItems.map((item, index) => {
        return (
          <NavLink
            to={`/${item.url}`}
            className={`navigate-container d-flex align-items-center justify-content-center flex-column ${
              `/${item.url}` === location.pathname && "active-navigate"
            }`}
            key={`bottom-nav-item-${index}`}
            // onClick={() => window.scrollTo(0, 0)}
          >
            {item.component}
            {item.title}{" "}
          </NavLink>
        );
      })}
    </div>
  );
}
